import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { SignUpElement } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { ConnectButton } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/ConnectButton";
import { LandingPageContext } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/LandingPageContext";
import { Section } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/Section";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { useContext } from "react";
export var ConnectCTASection = function() {
    var clickEvent = useContext(LandingPageContext).clickEvent;
    return /*#__PURE__*/ _jsxs(Section, {
        color: Core.surface.inverse,
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "10x"
            }),
            /*#__PURE__*/ _jsxs(Column, {
                gap: {
                    mobileAndAbove: "3x",
                    tabletAndAbove: "4x"
                },
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "displayMSerifRegular",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "ie/8jr",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Say goodbye to manual data entry"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(ConnectButton, {
                        onClick: function() {
                            return clickEvent === null || clickEvent === void 0 ? void 0 : clickEvent("bottom");
                        },
                        element: SignUpElement.BELOW_FOLD
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "10x"
            })
        ]
    });
};
